import { useQuery } from '@tanstack/react-query'
import { Link, Navigate, useParams } from 'react-router-dom'
import { Icon } from '../../components/icons'
import { Picture } from '../../components/Picture'
import { HeaderMetrics, PageHeader, Pill, Spinner } from '../../components/ui'
import { api } from '../../lib/api/client'
import { Settings } from '../school/Settings'
import { AiControl } from './AiControl'
import { PlatformEmailControl } from '../email/PlatformEmailControl'
import './schools.css'

export function SchoolControl() {
  const { schoolId } = useParams()
  const schools = useQuery({
    queryKey: ['platform', 'schools'],
    queryFn: api.platformSchools,
  })
  if (!schoolId) return <Navigate to="/schools" replace />
  if (schools.isLoading) return <Spinner label="Loading school" />

  const school = schools.data?.find((candidate) => candidate.id === schoolId)
  if (!school) return <Navigate to="/schools" replace />
  const ready = school.administrator_count > 0

  return (
    <div className="tc-page tc-school-control">
      <Link className="tc-school-back" to="/schools">
        <Icon.back size={16} />
        All schools
      </Link>
      <PageHeader
        eyebrow={school.branch || 'Main branch'}
        title={school.name}
        icon={school.logo_image_id
          ? <Picture id={school.logo_image_id} className="tc-page-header-logo" />
          : <Icon.schools size={20} />}
        description="Manage this school’s paper headers, people, permissions and details."
        actions={
          <div className="tc-school-header-actions">
            <Pill tone={ready ? 'success' : 'warning'}>
              {ready ? 'Handed off' : 'Needs administrator'}
            </Pill>
            <HeaderMetrics
              label="School overview"
              items={[
                { value: school.active_users, label: 'Active people' },
                { value: school.pending_invitations, label: 'Pending invites' },
                {
                  value: school.administrator_count ? 'Assigned' : 'Missing',
                  label: 'Administrator',
                  tone: school.administrator_count ? 'default' : 'warning',
                },
              ]}
            />
          </div>
        }
      />
      {/* The platform panels sit inside the tab they belong to rather than
          floating above the tab strip, where they were the first thing on the
          screen no matter which tab you had come to use. */}
      <Settings
        schoolId={school.id}
        hideHeading
        platformAiControl={<AiControl schoolId={school.id} />}
        platformEmailControl={<PlatformEmailControl schoolId={school.id} />}
      />
    </div>
  )
}
